import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import CommonDatePicker from "../datepicker/CommonDatePicker";
import "rsuite/dist/rsuite.min.css";
import config from "../common/Config";
import { setTableWidths, getTableWidths } from "../../data/postAPi";
import "../../components/css/custom-filter.css";
const RejectSales = () => {
  const [dates, setDates] = useState([null, null]);
  const [rejectedTotal, setRejectedTotal] = useState("");
  const [currentRejectedTotal, setCurrentRejectedTotal] = useState("");
  const tableRef = useRef(null);
  const accessToken = localStorage.getItem("accessToken");
  const [colWidths, setColWidths] = useState([120, 120, 200, 120, 150, 120]);
  const userId = localStorage.getItem("userId");
  const tableName = "rejectSalesTable";

  // Debounce for saving widths
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;

  const startResizing = (index, e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];
    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  useEffect(() => {
    async function fetchWidths() {
      try {
        const res = await getTableWidths(userId, tableName);
        if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
          setColWidths(res.data.widths);
        } else {
          setColWidths([120, 120, 200, 120, 150, 120]);
        }
      } catch (e) {
        setColWidths([120, 120, 200, 120, 150, 120]);
      }
    }
    fetchWidths();
  }, []);

  // Handle form submit, set date range and trigger getRejectedSalesList immediately
  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    getRejectedSalesList();
  };

  // Fetch rejected sales list from API
  const getRejectedSalesList = () => {
    const $table = $(tableRef.current);
    // Destroy any existing DataTable instance to reinitialize with new data
    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }
    // Format start and end dates (if selected)
    let startDate = dates[0] ? dates[0].toLocaleDateString("en-GB").split("/").reverse().join("-") : "";
    let endDate = dates[1] ? dates[1].toLocaleDateString("en-GB").split("/").reverse().join("-") : "";
    $table.DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: `${config.API_URL}/get_reject_sales`,
        type: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return $.extend({}, d, {
            draw: d.draw,
            start: d.start,
            length: d.length,
            start_date: startDate,
            end_date: endDate,
            authorization: `Bearer ${accessToken}`,
          });
        },
        dataSrc: function (json) {
          if (json && json.data && Array.isArray(json.data)) {
            setRejectedTotal(json.total_rejected_total || "");
            setCurrentRejectedTotal(json.total_rejected_total1 || "");
          }
          return Array.isArray(json.data) ? json.data : [];
        },
      },
      language: {
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous",
        },
        search: "Search:",
      },
      columns: [
        { data: "date" },
        {
          data: "reference_no",
          render: (data, type, row) => {
            return `<a class="underlined-link" href="${config.BASE_URL}/order_summary/print/${row.id}">${row.reference_no}</a>`;
          },
        },
        { data: "customer_with_account" },
        { data: "grand_total" },
        { data: "sale_person" },
        {
          data: "sale_status",
          render: (data, type, row) => {
            let badgeColor = "";
            switch (row.sale_status) {
              case "Rejected":
                badgeColor = "bg-warning text-dark";
                break;
              case "Intransit":
                badgeColor = "bg-success text-white";
                break;
              case "Undelivered":
                badgeColor = "bg-danger text-white";
                break;
              default:
                badgeColor = "bg-secondary text-white";
                break;
            }
            return `<span class="badge ${badgeColor}">${row.sale_status}</span>`;
          },
        },
      ],
      order: [],
      pageLength: 50,
    });
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    getRejectedSalesList();
    return () => {
      if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
    // eslint-disable-next-line
  }, [dates]);

  return (
    <>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#">
                <i className="fa fa-home"></i>
              </a>{" "}
              &gt; <a href="#">Dashboard</a> &gt;{" "}
              <span className="last-crumb">Rejected Sales</span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container position-relative">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div>
                <div className="row reject-sales-filter-row">
                  <div className="col-md-12 col-sm-12 d-flex gap-3">
                    <CommonDatePicker
                      value={dates}
                      onChange={(value) => {
                        setDates(value);
                        // Automatically trigger search when dates are selected
                        if (value && value[0] && value[1]) {
                          setTimeout(() => {
                            handleSubmit();
                          }, 100);
                        }
                      }}
                      format="dd/MM/yyyy"
                      character=" - "
                      style={{ width: '100%' }}
                    />
                  </div>
                  {/* <div className="col-md-12 col-lg-6 col-sm-12">
                    <div className="row">
                      <div className="col-12 col-lg-5 col-sm-5">
                        <div className="row mb-3 padd-0">
                          <label className="col-6 col-lg-6 col-sm-6">
                            <b>Rejected Total:</b>
                          </label>
                          <div className="col-6 col-lg-6 col-sm-6">
                            {rejectedTotal}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 col-sm-6">
                        <div className="row mb-3 padd-0">
                          <label className="col-6 col-lg-6 col-sm-6">
                            <b>Current Total:</b>
                          </label>
                          <div className="col-6 col-lg-6 col-sm-6">
                            {currentRejectedTotal}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="dashboard reject-sales-table">
                  <div className="col-md-12 col-lg-12 col-xs-12">
                    <div className="verical-scrl-wrapper reject-sales" id="style-3">
                      <table
                        className="table table-bordered dataTable resizable"
                        ref={tableRef}
                      >
                        <thead>
                          <tr>
                            {[
                              "Order Date",
                              "Order Id",
                              "Customers",
                              "Order Amount",
                              "Sales Person Name",
                              "Action",
                            ].map((header, idx) => (
                              <th
                                key={header}
                                style={{ width: colWidths[idx], minWidth: 50, position: "relative" }}
                              >
                                {header}
                                {idx < colWidths.length - 1 && (
                                  <div
                                    className="th-resizer"
                                    onMouseDown={(e) => startResizing(idx, e)}
                                  />
                                )}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>{/* DataTable will populate this dynamically */}</tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RejectSales;